import styled, { keyframes } from 'styled-components';

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

export const Loader = styled.div.withConfig({
    shouldForwardProp: (prop) => !['color'].includes(prop),
})`
    padding: 10px;
    border: 6px solid #fff;
    ${(props) => props.color && `border: 6px solid ${props.color};`}
    border-bottom-color: transparent;
    border-radius: 22px;
    animation: ${rotate} 1s infinite linear;
    height: 0;
    width: 0;

    margin-top: 10px;
`;
